import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { usersData } from "@/data/users-data";
import { usersColumns } from "./columns";
import Filters from "./filters";

export type UsersTableDataType = (typeof usersData)[number];

export default function UsersTable() {
    const { table, setData } = useTanStackTable<UsersTableDataType>({
        tableData: usersData,
        columnConfig: usersColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 25,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });
    return (
        <div className="mt-14">
            <Filters table={table} />
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} />
            <TablePagination table={table} className="py-4" />
        </div>
    );
}
